import React from "react";

const DEFAULT_MESSAGE =
    "Virtalibry has just been updated. Refresh this page to continue with the latest version.";

const CacheUpdateNotice = ({mode = "modal", message = DEFAULT_MESSAGE, onRefresh}) => {
    const normalizedMode = String(mode || "modal").toLowerCase();
    const text = message || DEFAULT_MESSAGE;

    const handleRefresh = () => {
        if (typeof onRefresh === "function") {
            onRefresh();
            return;
        }
        window.location.reload();
    };

    if (normalizedMode === "green_line") {
        return (
            <div
                style={{
                    background: "#198754",
                    color: "white",
                    padding: "10px",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: 14,
                }}
                role="status"
            >
                {text}
            </div>
        );
    }

    return (
        <div
            className="modal show"
            tabIndex="-1"
            style={{display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)"}}
        >
            <div className="modal-dialog modal-sm" style={{margin: "auto"}}>
                <div className="modal-content text-muted">
                    <div className="modal-header small" style={{height: 40}}>
                        <h6 className="modal-title small fs-6">
                            {normalizedMode === "book_modal" ? "Book Tools Updated!" : "Virtalibry Updated!"}
                        </h6>
                    </div>
                    <div
                        className="modal-body small mb-0 pb-2 pt-2"
                        style={{lineHeight: "1.6", paddingBottom: 0, paddingTop: 0}}
                    >
                        <p className="small text-muted mb-1">{text}</p>
                    </div>
                    <div
                        className="modal-footer small d-flex align-items-center justify-content-center gap-2 px-2 mt-0"
                        style={{height: 50, paddingTop: 0, paddingBottom: 0}}
                    >
                        <button
                            type="button"
                            className="btn btn-sm btn-success align-items-center shadow-sm d-flex justify-content-center"
                            onClick={handleRefresh}
                        >
                            Click to Refresh and Continue
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CacheUpdateNotice;
